import helpers from 'src/helpers'
export default {
  esacPointsVoucherList: state => {
    return state.voucherList
  },
  esacPointsRedemptionList: state => {
    return state.redemptionList
  },
  esacPointsRedemptionData: state => {
    return state.redemption.data
  },
  esacPointsBalance: state => {
    return state.balance
  },
}
